import Grain from '../modules/Grain'
import Scrollbar from 'smooth-scrollbar'

export default class BaseController {

  initScrollbar() {
    let damp = .3
    if (window.innerWidth >= 640) damp = .3
    else damp = .05
    const $header = document.querySelector('.header')
    const $scrollbar = document.querySelector('#my-scrollbar')
    this.scrollbar = Scrollbar.init($scrollbar, {damping: damp})
    this.scrollbar.addListener((event) => {
      $header.style.transform = `translateY(${-event.deltaY}px)`
    })

    this.initAnchorScroll();
  }

  initAnchorScroll() {
    const links = document.querySelectorAll('a[href^="#"]'); // Sélectionne les liens avec href commençant par #
    links.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault(); // Empêche le comportement par défaut du lien
            const targetId = link.getAttribute('href').slice(1); // Récupère l'ID de l'ancre
            const targetElement = document.getElementById(targetId);

            if (targetElement && window.innerWidth >= 1050) {
                const offset = targetElement.getBoundingClientRect().top + this.scrollbar.offset.y;
                this.scrollbar.scrollTo(0, offset, 1000); // Défile en douceur jusqu'à l'élément
            } else {
              const offset = targetElement.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({ 
                top: offset, 
                left: 0, 
                behavior: 'smooth' 
              });
            }
        });
    });
}

  getScroll() {
    return parseInt(window.getComputedStyle(document.querySelector('.scroll-content')).transform.split(',')[5]) * -1
  }

  initGrain() {
    const $grains = document.querySelectorAll('.js-grain')
    // for (const $grain of $grains) new Grain($grain)
  }

  isOnWindow(element)
  {
    const elementOffset = element.getBoundingClientRect().y
    const status = 
    {
      offsetY: 0,
      isOnWindow: false,
    }

    if(elementOffset - (window.innerHeight) <= 0 && elementOffset + element.offsetHeight >= 0)
    {
      status.offsetY = - (element.getBoundingClientRect().y - window.innerHeight)
      status.isOnWindow = true
    }
    else
    {
      status.isOnWindow = false
    }

    return status
  }
}